import { render } from "./Navigation.vue?vue&type=template&id=571b6871&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=571b6871&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-571b6871"

export default script